module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1r3n6n-e88de3bdb3f3c482535de9a60f51855f.svg";